import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { Button, FormGroup } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import './style.css';

const checkoutList = {
  site_id: '',
  line_items: [],
};
const Checkout = ({
  viewCart = [],
  sitesData = [],
  checkoutOrder,
  addInCart,
  getSitesList,
  history,
}) => {
  const subTotal = [];
  const { baseUrl } = useContext(BaseUrl);
  const [checkoutData, setCheckoutData] = useState(checkoutList);
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const tableData = ['product_id', 'quantity'];
    if (viewCart.length > 0) {
      const data = viewCart.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: element[key],
          }))
        )
      );
      setCheckoutData({ ...checkoutData, line_items: data });
    }
  }, [viewCart?.length]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSitesList();
      setIsLoading(false);
    })();
  }, [getSitesList]);

  const totalCalc = () => subTotal.reduce((a, b) => a + b, 0);

  const checkoutHandle = async (e) => {
    setIsConfirm(false);
    setIsLoading(true);
    const res = await checkoutOrder(checkoutData);
    setIsLoading(false);
    if (res?.status === true) {
      setIsSuccess(true);
    }
  };

  const onSubmitConfirmation = (e) => {
    e.preventDefault();
    setIsConfirm(true);
  };

  const isConfirmHandle = () => setIsConfirm(false);

  const isSuccessHandle = async () => {
    localStorage.removeItem('cartList');
    await addInCart([]);
    setIsSuccess(false);
    history.push(`${baseUrl}/brand-activation/products`);
  };

  const handleRemove = async (index) => {
    viewCart.splice(index, 1);
    await addInCart([...viewCart]);
  };

  return (
    <Layout title={localization.checkout} isLoading={isLoading}>
      {viewCart?.length > 0 && (
        <div className="checkout-wrapper">
          {viewCart.map((item, index) => {
            const total = item.quantity * item.selling_price;
            subTotal.push(total);
            return (
              <div key={index} className="product-row">
                <Link
                  className="prod-img"
                  to={`${baseUrl}/brand-activation/product-details/${item.product_id}`}
                >
                  <img src={item.image} alt={item.name} />
                </Link>
                <div className="details">
                  <div className="details-left">
                    <Link
                      className="title"
                      to={`${baseUrl}/brand-activation/product-details/${item.product_id}`}
                    >
                      {item.name}
                    </Link>
                    <div className="desc">{item.description}</div>
                    <div className="price">
                      Price:{' '}
                      <span className="amt">{` ₹${item.selling_price}`}</span>
                    </div>
                    <div className="quantity">{`Qty: ${item.quantity}`}</div>
                    <button onClick={() => handleRemove(index)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path
                          fill-rule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                        />
                      </svg>
                    </button>
                  </div>
                  <div className="sub-total">
                    <div className="sub-total-title">Sub Total</div>
                    <div className="sub-amt">
                      <span className="amt">₹{total}</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="total">
            <span>Total: </span>
            <span className="amt"> ₹{totalCalc()}</span>
          </div>
          <form
            className="checkout-section"
            onSubmit={(e) => onSubmitConfirmation(e)}
          >
            <div className="panel-body d-md-flex">
              <DropDownInput
                disabled={sitesData.length === 0}
                label={localization.siteName}
                data={sitesData}
                required
                isStarRequired={true}
                errorMsg={localization.statusErrorMsg}
                getIdValue={(value) => {
                  setCheckoutData({ ...checkoutData, site_id: value.id });
                }}
              />
              <div className="form-group full-width">
                <Button type="submit">{localization.checkout}</Button>
              </div>
            </div>
          </form>
        </div>
      )}
      <ModalPop
        title={localization.conf}
        show={isConfirm}
        handleModalHide={isConfirmHandle}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h4>{localization.isPlaceOrder}</h4>
          <FormGroup className="d-md-flex btn-group">
            <Button onClick={isConfirmHandle} className="btn-transparent">
              {localization.cancel}
            </Button>
            <Button onClick={checkoutHandle}>{localization.continue}</Button>
          </FormGroup>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.conf}
        show={isSuccess}
        handleModalHide={isSuccessHandle}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h4>{localization.orderSuccessfullyPlaced}</h4>
          <FormGroup className="d-md-flex btn-group">
            <Button onClick={isSuccessHandle}>{localization.continue}</Button>
          </FormGroup>
        </div>
      </ModalPop>
    </Layout>
  );
};

Checkout.propTypes = {
  viewCart: PropTypes.array,
  sitesData: PropTypes.array,
  checkoutOrder: PropTypes.func,
};

export default Checkout;
